import React, { useCallback, useEffect, useRef, useState } from 'react'
import cls from 'classnames'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'

import NavigationPopup from '../NavigationPopup'

function DropdownItem({ id, className, text, items, history }) {
  const wrapperRef = useRef(null)
  const [showDropdown, triggerDropdown] = useState(false)
  const hideDropdown = useCallback(() => {
    triggerDropdown(false)
  })
  const hideDropdownByOutsideClick = useCallback(
    (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        hideDropdown()
      }
    },
    [wrapperRef]
  )

  useEffect(() => {
    document.addEventListener('mousedown', hideDropdownByOutsideClick)
    return () => document.removeEventListener('mousedown', hideDropdownByOutsideClick)
  })

  return (
    <div className={cls(className, 'navigation-item')}>
      <div
        id={id}
        title={text}
        className="dropdown-trigger navigation-item-content toggle-text"
        onClick={() => triggerDropdown(!showDropdown)}
      >
        <span className="dropdown-trigger mw150">{text}</span>
        <img
          src="/static/webapp/images/navigation/nav-triangle.svg"
          className="dropdown-trigger triangle"
        />
      </div>

      {showDropdown && (
        <NavigationPopup
          ref={wrapperRef}
          right="10px"
          width="150px"
          className="navigation-item-dropdown"
        >
          <div className="content dropdown">
            {items.map((e) => (
              <DropdownMenuItem
                key={e.text}
                text={e.text}
                type={e.type}
                url={e.url}
                blocked={e.blocked}
                id={e.id}
                className={e.className}
                history={history}
                hideDropdown={hideDropdown}
              />
            ))}
          </div>
        </NavigationPopup>
      )}
    </div>
  )
}

function DropdownMenuItem({ text, id, className, type, url, history, hideDropdown, blocked }) {
  const handleClick = useCallback(
    (e) => {
      if (blocked) return
      if (type === 'internal') {
        history.push(url)
      } else if (type === 'external') {
        window.open(url, '_self')
      }
      hideDropdown()
    },
    [url, type]
  )

  return (
    <div key={text} id={id} className={className} onClick={handleClick}>
      {text}
    </div>
  )
}

export default styled(withRouter(DropdownItem))`
  display: inline-block;
  position: relative;
  .toggle-text {
    padding: 10px;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
  }
`
